import { MenuItem } from "@chakra-ui/menu";
import { useProgressContext } from "lib/context/progressContext";
import { useUploadFiles } from "lib/hooks";
import { FileIcon } from "lib/icons/file"
import { useRef, useEffect } from "react";
import { usePackContext } from "domains/pack";

export const AddFilesMenuItem = () => {
  const ref = useRef(null);
  const { packId } = usePackContext();
  const { uploadFiles, percent } = useUploadFiles(packId);
  const { setProgress } = useProgressContext();

  useEffect(() => {
    setProgress(percent);
  }, [percent, setProgress]);

  const addFiles = async () => {
    await uploadFiles(ref.current.files);
    ref.current.value = '';
  }

  return (
    <>
      <MenuItem icon={<FileIcon boxSize="20px" />} onClick={() => ref.current.click()}>
        Add files
      </MenuItem>
      <input
        ref={ref}
        id={`file-uploader`}
        data-testid="file-upload"
        type="file"
        onChange={() => addFiles()}
        multiple
        style={{ display: 'none' }}
      />
    </>
  )
}
